export const INITIAL_VALUES = {
  idEquipmentType: null,
  number: '',
  code: '',
  idStation: null,
  serialNumber: '',
  status: null
};

export const VALIDATIONS = {
  idEquipmentType: { required: true },
  number: { required: true },
  code: { required: true },
  idStation: { required: true },
  serialNumber: { required: true },
  status: { required: true }
};